import styled from "styled-components";

const CarSection = styled.div`
  background: var(--inner-section-bg);
  border-right: 1px solid #e5e5e5;
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-family: "latobold";

  cursor: pointer;
  .car-icon {
    max-width: 30px;
  }
  h3 {
    font-size: 32px;
    line-height: 48px;
  }
  span {
    font-size: 10px;
    line-height: 11px;
    font-weight: 500;
    text-align: center;
  }
`;
const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  &.grid-card {
    padding: 0 14px;
  }
  .list-view-car-icon {
    width: 29px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
  }
  .msg-section {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 10px 0;
    flex: 1;
    flex-direction: column;
    .uper-section {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      flex: 1;
      width: 100%;
      .signal-icon,
      .chat-download,
      .top-icon {
        > div,
        > span {
          display: inline-flex;
          align-items: center;
        }
      }
      .chat-download {
        display: flex;
        align-items: center;
        gap: 4px;

        button {
          background: transparent;
          border-radius: 30px;
        }
      }
    }
    .player-section {
      width: 100%;
      .flex {
        display: flex;
        align-items: center;
      }
      .player-name {
        display: grid;
        align-items: center;
        gap: 30px;
        color: var(--text-secondary);
        font-size: 16px;
        span {
          display: inline-flex;
          align-items: center;
          gap: 10px;
        }
      }
      .pace-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        span {
          font-weight: 700;
          font-size: 16px;
          line-height: 150.5%;
        }
        .pace {
          color: var(--text-secondary);
          font-size: 16px;
          line-height: 150.5%;
          font-weight: 400;
        }
      }
    }
    button {
      font-size: 13px;
      line-height: 150.5%;
      color: #1d1d1d;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      border-radius: 15px;
      padding: 5px;
      cursor: pointer;
      background: linear-gradient(
        180deg,
        #d9d9d9 0%,
        rgba(217, 217, 217, 0) 100%
      );
      border: 1px solid #636f7c;
      border-radius: 6px;
    }
    .number-dig {
      font-size: 18px;
      line-height: 21px;
      color: #af815c;
      font-family: "latobold";
    }
    .top-icon {
      display: flex;
      align-items: center;
      gap: 6px;
      
    }
  }
  .time-section {
    border-top: 1px solid #e5e5e5;
    padding: 8px 0 13px;
    display: flex;
    align-items: center;
    gap: 15px;
    p {
      font-size: 12px;
      line-height: 150.5%;
      color: #000;
    }
    .date-info {
      color: #0009;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
`;
const CardWrapper = styled.div`
  background: var(--inner-section-bg);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  min-height: 175px;
  width: 100%;
  transition: width 0.3s;
  border: 1px solid #999999;
  border-radius: 6px;

  &.grid-view-card {
    border: none;
    border-radius: 0;
  }
  &.table-view {
    width: 100%;
    min-height: 62px;
    .non-table {
      display: none;
    }
    .table-ui {
      display: flex;
      width: 100%;
    }
  }

  .table-ui {
    display: none;
  }
  &.list-view {
    .table-ui {
      display: none;
    }
    min-height: auto;
    transition: width 0.3s;
    ${CarSection} {
      padding: 0 2px;

      h3 {
        font-size: 17px;
        line-height: 29px;
        min-width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    }
    ${InfoSection} {
      .msg-section {
        align-items: center;
        .uper-section {
          align-items: center;
          .flex {
            display: flex;
            align-items: center;
            gap: 2px;
          }
          .chat-download {
            display: flex;
            align-items: center;
            gap: 4px;
          }
        }
        button {
          width: 30px;
          height: 26px;
          align-items: center;
          display: flex;
          padding: 0;
          justify-content: center;
          border-radius: 6px;
          background: linear-gradient(
            180deg,
            #d9d9d9 0%,
            rgba(217, 217, 217, 0) 100%
          );
          border: 1px solid #636f7c;
          border-radius: 6px;
        }
        .top-icon {
          .battery-icon {
            /* width: 25px; */
          }
        }
      }
    }
    .card-view {
      display: none;
    }
    .list-view {
      display: inline-flex;
    }
    .signal-icon {
      display: inline-flex;
      gap: 9px;
      align-items: center;
    }
  }
  &.card-view {
    .card-view {
      display: inline-flex;
    }
    .list-view {
      display: none;
    }
  }
`;
const TableWrapper = styled.div``;

const DistanceCover = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bolder;
  &.only-text {
    font-size: 14px;
    position: relative;
  }
`;

export {
  CardWrapper,
  CarSection,
  InfoSection,
  TableWrapper,
  DistanceCover,
  Text,
};
